import Highcharts from "highcharts"

export const getStackedColumnChartOptions = (
  categories: string[],
  successData: number[],
  failedData: number[],
  viewType: "daily" | "monthly",
  onPointClick?: (index: number, seriesName: string) => void,
  selectedIndex?: number | null
): Highcharts.Options => {
  return {
    chart: {
      type: "column",
      height: 350
    },
    title: {
      text: ""
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: categories,
      labels: {
        rotation: viewType === "daily" ? -45 : 0,
        style: {
          fontSize: "11px"
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: "Number of API Calls"
      },
      stackLabels: {
        enabled: false
      }
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      backgroundColor: "white",
      borderColor: "#CCC",
      borderWidth: 0,
      shadow: false
    },
    tooltip: {
      backgroundColor: "#42405A",
      borderColor: "#42405A",
      borderRadius: 5,
      shadow: false,
      style: {
        color: "#ffffff",
        fontSize: "12px"
      },
      headerFormat: "<b>{point.x}</b><br/>",
      pointFormat:
        "{series.name}: <b>{point.y}</b><br/>" +
        "Total: <b>{point.stackTotal}</b>"
    },
    plotOptions: {
      column: {
        stacking: "normal",
        cursor: "pointer",
        dataLabels: {
          enabled: false
        },
        states: {
          hover: {
            brightness: 0.1,
            enabled: true
          }
        },
        point: {
          events: {
            click: function () {
              if (onPointClick) {
                onPointClick(this.index, this.series.name)
              }
            }
          }
        }
      }
    },
    series: [
      {
        name: "Successful Calls",
        type: "column",
        data: successData.map((value, index) => {
          const isSelected = selectedIndex === index
          return {
            y: value,
            // Apply hover-like color when selected (lighter/brighter green)
            color: isSelected ? "#34D399" : undefined
          }
        }),
        color: "#10B981" // Green
      },
      {
        name: "Failed Calls",
        type: "column",
        data: failedData.map((value, index) => {
          const isSelected = selectedIndex === index
          return {
            y: value,
            // Apply hover-like color when selected (lighter/brighter red)
            color: isSelected ? "#F87171" : undefined
          }
        }),
        color: "#EF4444" // Red
      }
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600
          },
          chartOptions: {
            legend: {
              enabled: true
            },
            xAxis: {
              labels: {
                rotation: -45
              }
            }
          }
        }
      ]
    }
  }
}
